import styled from '@emotion/styled';
import { Flex } from 'components';

export const AttachLink = styled.label`
  min-width: 90px;
  font-size: 15px;
  color: ${({ theme }) => theme.colors.tertiary};

  &:hover {
    cursor: pointer;
  }
`;

export const AttachInput = styled.input`
  border: 0;
  clip: rect(0, 0, 0, 0);
  width: 0;
  height: 1px;
  overflow: hidden;
  padding: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CommentForm = styled.form`
  max-width: 100%;
  width: 800px;
  margin: 20px auto 0;
  padding: 0 25px 25px;
`;

export const CommentInput = styled.textarea`
  width: 100%;
  min-height: 120px;
  margin-bottom: 10px;
  padding: 12px;
  resize: none;
  border: 1px solid #ddd;
  font-family: ${({ theme }) => theme.fonts.secondary};
  outline: none;
  transition: all ease-in-out 0.2s;

  &.has-error {
    background-color: ${({ theme }) => theme.colors.backgroundDanger};
    border-color: ${({ theme }) => theme.colors.borderDanger};
    box-shadow: none;
  }
`;

export const ErrorMessagePlaceholder = styled.div`
  height: 21px;
`;

export const RemoveFileLink = styled.a`
  display: inline-block;
  margin-top: 5px;
`;

export const SelectedFiles = styled.div`
  padding: 0 30px;
  font-size: 14px;
`;

export const SelectedFileName = styled.span`
  color: ${({ theme }) => theme.colors.secondary};
`;

export const SpinnerWrapper = styled(Flex)`
  padding: 25px 0;
`;

export const SubmitWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  min-width: 90px;
`;
